<!--
 * @Author: guojia 66291979@qq.com
 * @Date: 2024-05-10 14:35:50
 * @LastEditors: pluto.guo 66291979@qq.com
 * @LastEditTime: 2025-01-03 15:23:48
 * @FilePath: /lobby/src/components/NavTab.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <van-sticky :offset-top="offSetTop" z-index="11">
    <div class="nav">
      <ul>
        <li
          v-for="(item, index) in tabs"
          :key="index"
          :class="select == item.id ? 'nav_active' : ''"
          @click="onSelectTab(item)"
        >
          <i :class="`bi ${item.cover}`" :style="item.color? `color:${item.color}`: ''"></i>
          <p :style="item.color? `color:${item.color}`: ''">{{ item.title }}</p>
        </li>
      </ul>
    </div>
  </van-sticky>
</template>
<script>
// import { BUS, POPUP } from '@/event/EventCenter'
import { GAME_NAV_TAB_TYPE, useLobbyStore } from '@/stores/lobby.js'
import { useUserStore } from '@/stores/user'
import { mapActions, mapState } from 'pinia'
import { downloadAPK, formatNavTab, savePWA } from '@/utils/helper'
import { config } from '@/common/config'
import { BUS } from '@/event/EventCenter'
export default {
  name: 'DhNavTab',
  computed: {
    ...mapState(useLobbyStore, [
      'hasStickyBanner',
      'checkShowAPPDownloadBanner',
      'navtabType',
    ]),
    ...mapState(useUserStore, ['isLogin', 'country'])
  },
  data() {
    return {
      offSetTop: 56,
      resBaseUrl: config.resBaseUrl,
      // Home | Games |  Aviator | Live | Football | Basketball |
      tabs: [
        {
          id: 1,
          name: 'Home',
          title: 'Home',
          cover: 'bi-house'
        },
        {
          id: 2,
          name: 'Games',
          title: 'Games',
          cover: 'bi-controller',
          color: '#ff8834'
        },
        {
          id: 4,
          name: 'Live',
          title: 'Live',
          cover: 'bi-collection-play'
        },
        {
          id: 5,
          name: 'Football',
          title: 'Football',
          cover: 'bi-cookie'
        },
        {
          id: 6,
          name: 'Basketball',
          title: 'Basketball',
          cover: 'bi-dribbble'
        }
      ],
      select: 0
    }
  },
  watch: {
    hasStickyBanner(newvalue, oldvalue) {
      if (newvalue != oldvalue) {
        this.offSetTop = this.checkShowAPPDownloadBanner
          ? newvalue
            ? 133
            : 105
          : newvalue
            ? 86
            : 60
      }
    },
    checkShowAPPDownloadBanner(newvalue, oldvalue) {
      if (newvalue != oldvalue) {
        this.offSetTop = newvalue ? 86 : 60
      }
    }
  },
  mounted() {
    this.offSetTop = this.checkShowAPPDownloadBanner
      ? this.hasStickyBanner
        ? 133
        : 105
      : this.hasStickyBanner
        ? 86
        : 60
    setTimeout(() => {
      this.onSelectTab(this.tabs[0])
    }, 1000);
  },
  methods: {
    formatNavTab,
    ...mapActions(useLobbyStore, { selectFunctionTab: 'selectFunctionTab' }),
    onSelectTab(item) {
      this.select = item.id
      if(item.id == 2){
        // 展示游戏列表
        useLobbyStore().navtabType = GAME_NAV_TAB_TYPE
      }else{
        this.$bus.$emit(BUS.CHANGE_SPROT_NAV_TAB, item)
      }
      // if (['history', 'collect'].includes(item.name.toLowerCase()) && !this.isLogin) {
      //   this.$bus.$emit(BUS.SHOW_POPUP, { from: 'NavTab', to: POPUP.LOGIN, show: true })
      // } else {
      //   this.selectFunctionTab(index)
      //   this.$bus.$emit(BUS.UPDATE_GAME_LIST)
      // }
    },
    onDownLoadAPk() {
      downloadAPK(this.country)
    },
    onSavePwa() {
      savePWA()
    }
  }
}
</script>
<style lang="scss" scoped>
.nav {
  display: flex;
  width: 100%;
  height: 1.1rem;
  background-color: #000;
  padding: 1.5% 3%;
  margin-left: -0.1rem;
  margin-top: -0.3rem;
  // overflow: hidden;

  ul {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    // overflow: scroll;
    // white-space: nowrap;
    margin: 0px;
    padding-right: 3%;
    scrollbar-width: none;
    /* firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
    overflow-x: scroll;
    overflow-y: hidden;
  }

  li {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 0.24rem;
    color: #ceb45f;
    text-align: center;
    // display: inline-block;
    display: -moz-inline-stack;
    min-width: 1.05rem !important;
    min-height: 0.85rem !important;
    margin: 0;
    padding: 0.1rem;
    border-radius: 0.2rem;
    border: 0.02rem solid #000;

    i {
      font-size: 0.48rem;
      color: #ceb45f;
    }

    p {
      width: max-content;
      line-height: 0;
      margin: 0.14rem 0;
      padding: 0;
    }
  }

  .nav_active {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid #ffddac !important;
    // color: #ffddac !important;
    min-width: 1.05rem !important;
    min-height: 0.85rem !important;

    i {
      color: #ffddac !important;
    }

    p {
      color: #ffddac !important;
    }
  }
}
</style>
